import { render, staticRenderFns } from "./DatiUtente.vue?vue&type=template&id=540b1ec8"
import script from "./DatiUtente.vue?vue&type=script&lang=js"
export * from "./DatiUtente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports